export default {
  'listBuilder.title': 'List Builder',
  'listBuilder.back': 'Back',
  'listBuilder.canvas': 'Canvas',
  'listBuilder.data': 'Data',
  'listBuilder.publish': 'Publish',
  'listBuilder.publish.success': 'List published successfully',
  'listBuilder.publish.error': 'Error publishing',
  'listBuilder.error.notFound': 'List not found or does not exist',
  'listBuilder.published': 'Published',
  'listBuilder.publish.error.noFields': 'Add at least one field before publishing',
  'listBuilder.publish.error.duplicateDisplayText':
    'Display names must be unique. Duplicates: {names}',
  'listBuilder.publish.tooltip.readOnly': 'This version is already published and cannot be edited',
  'listBuilder.messages.saved': 'Settings saved',
  'listBuilder.settings': 'Settings',

  'listBuilder.field.add': 'Add',
  'listBuilder.field.edit': 'Edit field',
  'listBuilder.field.delete': 'Delete field',
  'listBuilder.field.showMore': 'Show more',
  'listBuilder.field.showLess': 'Show less',

  'listBuilder.settings.group': 'List group',
  'listBuilder.settings.defaultDateRange': 'Default date range',
  'listBuilder.settings.dateRange.default': 'No restriction',
  'listBuilder.panel.settings': 'General Settings',
  'listBuilder.panel.fields': 'Fields',
  'listBuilder.panel.traces': 'Traces',

  'listBuilder.canvas.fit': 'Fit to canvas',
  'listBuilder.canvas.fullscreen': 'Fullscreen',
  'listBuilder.canvas.exitFullscreen': 'Exit fullscreen',
  'listBuilder.canvas.zoomIn': 'Zoom in',
  'listBuilder.canvas.zoomOut': 'Zoom out',

  'listBuilder.canvas.empty': 'Your list starts here',
  'listBuilder.canvas.empty.description': 'Add fields to define the structure of your custom list',
  'listBuilder.canvas.empty.hint': 'Click on "Add" to start',

  'listBuilder.version.createdBy': 'Created by',
  'listBuilder.version.createdDate': 'Created date',
  'listBuilder.version.publishedBy': 'Published by',
  'listBuilder.version.publishedDate': 'Published date',

  'listBuilder.chat.error': 'Could not initialize chat',
  'listBuilder.chat.noConnection': 'No connection. Try again.',
  'listBuilder.chat.title': 'AI Assistant',
  'listBuilder.chat.open': 'Open chat',
  'listBuilder.chat.close': 'Close chat',

  'listBuilder.type.list': 'Table',
  'listBuilder.type.gantt': 'Gantt',
  'listBuilder.type.calendar': 'Calendar',
  'listBuilder.type.taskList': 'Task list',
  'listBuilder.type.taskBoard': 'Task Board',
  'listBuilder.type.cards': 'Cards',
  'listBuilder.type.map': 'Map',

  'listBuilder.fieldType.field': 'Field',
  'listBuilder.fieldType.processName': 'Process Name',
  'listBuilder.fieldType.processGroupName': 'Process Group',
  'listBuilder.fieldType.instanceName': 'Instance Name',
  'listBuilder.fieldType.instanceCreated': 'Created Date',
  'listBuilder.fieldType.instanceStatus': 'Status',
  'listBuilder.fieldType.applicantFullName': 'Applicant',
  'listBuilder.fieldType.approvedDate': 'Approved Date',
  'listBuilder.fieldType.rejectedDate': 'Rejected Date',
  'listBuilder.fieldType.applicantNames': 'Applicant Names',
  'listBuilder.fieldType.applicantLastNames': 'Applicant Last Names',
  'listBuilder.fieldType.applicantEmail': 'Applicant Email',
  'listBuilder.fieldType.applicantPosition': 'Applicant Position',
  'listBuilder.fieldType.instanceIdentifier': 'Instance Identifier',
  'listBuilder.fieldType.variable': 'Variable',
  'listBuilder.fieldType.commentsCount': 'Comments Count',
  'listBuilder.fieldType.applicantArea': 'Applicant Area',
  'listBuilder.fieldType.entityField': 'Entity Field',
  'listBuilder.fieldType.entityItemIdentifier': 'Entity Item ID',
  'listBuilder.fieldType.entityItemCreated': 'Entity Item Created',
  'listBuilder.fieldType.entityItemIsActive': 'Active',
  'listBuilder.fieldType.entityItemUserCreator': 'Created By',
  'listBuilder.fieldType.entityItemUserModifier': 'Modified By',
  'listBuilder.fieldType.instanceCurrentAction': 'Current Action',
  'listBuilder.fieldType.instanceGoToAction': 'Go To Action',
  'listBuilder.fieldType.instancePercentCompleted': '% Completed',

  'listBuilder.section.fields': 'Fields',
  'listBuilder.section.commands': 'Commands',
  'listBuilder.section.commands.empty': 'Click to add commands',
  'listBuilder.section.preFilters': 'Pre-Filters',
  'listBuilder.section.preFilters.empty': 'Click to add pre-filters',
  'listBuilder.section.groupBy': 'Group By',
  'listBuilder.section.groupBy.empty': 'Click to configure grouping',
  'listBuilder.section.references': 'References',
  'listBuilder.section.permissions': 'Permissions',
  'listBuilder.section.taskBoard': 'Task Board',
  'listBuilder.section.gantt': 'Gantt',
  'listBuilder.section.formMode': 'Form Mode',

  'listBuilder.ref.type.listField': 'List Field',
  'listBuilder.ref.dest.form': 'Form',
  'listBuilder.ref.fieldFrom': 'From {name}',
  'listBuilder.ref.fieldTo': 'To {name}',
  'listBuilder.ref.leftLabel': 'Configuration',

  'listBuilder.command.createRequest': 'Create request',
  'listBuilder.command.viewDetails': 'View details',
  'listBuilder.command.cancelRequest': 'Cancel request',
  'listBuilder.command.completeInfo': 'Complete information',
  'listBuilder.command.approveRequest': 'Approve request',
  'listBuilder.command.executeTask': 'Execute task',
  'listBuilder.command.signDocument': 'Sign document',
  'listBuilder.command.reassignTask': 'Reassign task',
  'listBuilder.command.massApprove': 'Mass approve',
  'listBuilder.command.export': 'Export',
  'listBuilder.command.massReject': 'Mass reject',
  'listBuilder.command.entityAdd': 'Add entity',
  'listBuilder.command.entityEdit': 'Edit entity',
  'listBuilder.command.entityDelete': 'Delete entity',
  'listBuilder.command.entityImport': 'Import entity',
  'listBuilder.command.customCommands': 'Custom commands',
  'listBuilder.command.massCancel': 'Mass cancel',
  'listBuilder.command.voidRequest': 'Void request',
  'listBuilder.command.massVoid': 'Mass void',
  'listBuilder.command.massExecuteTask': 'Mass execute task',
  'listBuilder.command.massCompleteInfo': 'Mass complete information',

  'listBuilder.preFilter.myRequests': 'My requests',
  'listBuilder.preFilter.instanceStatus': 'Instance status',
  'listBuilder.preFilter.formFieldValue': 'Form field value',
  'listBuilder.preFilter.pendingRequests': 'Pending requests',
  'listBuilder.preFilter.pendingCompleteInfo': 'Pending complete information',
  'listBuilder.preFilter.pendingApprovals': 'Pending approvals',
  'listBuilder.preFilter.pendingTasks': 'Pending tasks',
  'listBuilder.preFilter.pendingSign': 'Pending signature',
  'listBuilder.preFilter.interactions': 'User interactions',
  'listBuilder.preFilter.variableValue': 'Variable value',
  'listBuilder.preFilter.entityFieldValue': 'Entity field value',
  'listBuilder.preFilter.relatedToUser': 'Related to user',
  'listBuilder.preFilter.startedMode': 'Started mode',
  'listBuilder.preFilter.actionIdentifier': 'Action identifier',
  'listBuilder.preFilter.actionType': 'Action type',

  'listBuilder.drawer.addField.title': 'Add field',
  'listBuilder.drawer.editField.title': 'Edit field',
  'listBuilder.drawer.field.name': 'Display name',
  'listBuilder.drawer.field.type': 'Field type',
  'listBuilder.drawer.field.width': 'Width (px)',
  'listBuilder.drawer.field.order': 'Order',
  'listBuilder.drawer.field.visible': 'Visible',
  'listBuilder.drawer.field.sortable': 'Sortable',
  'listBuilder.drawer.field.style': 'Style',
  'listBuilder.drawer.field.sortDirection': 'Sort Direction',
  'listBuilder.drawer.field.filterable': 'Filterable',
  'listBuilder.drawer.field.searchable': 'Searchable',
  'listBuilder.drawer.field.editEnabled': 'Editable',
  'listBuilder.drawer.field.defaultSortingColumn': 'Default sorting column',
  'listBuilder.drawer.field.formId': 'Form',
  'listBuilder.drawer.field.fieldId': 'Form field',
  'listBuilder.drawer.field.variableId': 'Variable',
  'listBuilder.drawer.field.entityFieldId': 'Entity field',

  'listBuilder.field.style.none': 'None',
  'listBuilder.field.style.bold': 'Bold',
  'listBuilder.field.style.italic': 'Italic',
  'listBuilder.field.sort.asc': 'Ascending',
  'listBuilder.field.sort.desc': 'Descending',

  'listBuilder.drawer.commands.title': 'Configure Commands',
  'listBuilder.drawer.commands.description': 'Select commands available in the list',

  'listBuilder.drawer.preFilters.title': 'Configure Pre-Filters',
  'listBuilder.drawer.preFilters.operator': 'Logical operator',
  'listBuilder.drawer.preFilters.addFilter': 'Add filter',
  'listBuilder.drawer.preFilters.type': 'Filter type',
  'listBuilder.drawer.preFilters.processId': 'Process',
  'listBuilder.drawer.preFilters.form': 'Form',
  'listBuilder.drawer.preFilters.field': 'Field',
  'listBuilder.drawer.preFilters.variableId': 'Variable',
  'listBuilder.drawer.preFilters.entityFieldId': 'Entity field',
  'listBuilder.drawer.preFilters.userId': 'User',
  'listBuilder.drawer.preFilters.userDisplayValue': 'User display value',
  'listBuilder.drawer.preFilters.userExtraField': 'User extra field',
  'listBuilder.preFilter.userDisplay.fullName': 'Full name',
  'listBuilder.preFilter.userDisplay.email': 'Email',
  'listBuilder.preFilter.userDisplay.position': 'Position',
  'listBuilder.preFilter.userDisplay.area': 'Area',
  'listBuilder.preFilter.userDisplay.extraField': 'Extra field',
  'listBuilder.drawer.preFilters.value': 'Value',
  'listBuilder.drawer.preFilters.actionIdentifier.placeholder': 'e.g. approve_action',
  'listBuilder.drawer.preFilters.noFilters': 'No pre-filters configured',
  'listBuilder.drawer.preFilters.currentFilters': 'Current filters',
  'listBuilder.preFilter.operatorAnd': 'AND (All conditions)',
  'listBuilder.preFilter.operatorOr': 'OR (Any condition)',
  'listBuilder.preFilter.startMode.instant': 'Instant',
  'listBuilder.preFilter.startMode.automated': 'Automated',
  'listBuilder.preFilter.startMode.scheduled': 'Scheduled',
  'listBuilder.preFilter.actionType.completeInfo': 'Complete information',
  'listBuilder.preFilter.actionType.approval': 'Approval',
  'listBuilder.preFilter.actionType.executeTask': 'Execute task',
  'listBuilder.preFilter.actionType.signature': 'Digital signature',
  'listBuilder.preFilter.actionType.email': 'Email',
  'listBuilder.preFilter.actionType.conditional': 'Conditional',

  'listBuilder.drawer.groupBy.title': 'Configure Grouping',
  'listBuilder.drawer.groupBy.addField': 'Add grouping field',
  'listBuilder.drawer.groupBy.field': 'Field',
  'listBuilder.drawer.groupBy.fieldsSection': 'Fields to group by',
  'listBuilder.drawer.groupBy.noFields': 'No grouping fields configured',
  'listBuilder.drawer.groupBy.currentFields': 'Group by fields',
  'listBuilder.drawer.groupBy.percent': 'Percentage',
  'listBuilder.drawer.groupBy.percentSection': 'Percent grouping',
  'listBuilder.drawer.groupBy.percentHelp': 'Define percentage conditions over numeric fields',
  'listBuilder.drawer.groupBy.noPercents': 'No percent conditions configured',
  'listBuilder.drawer.groupBy.addPercent': 'Add percent condition',
  'listBuilder.drawer.groupBy.operator': 'Operator',
  'listBuilder.drawer.groupBy.value': 'Value (%)',
  'listBuilder.drawer.groupBy.op.equal': 'Equal to',
  'listBuilder.drawer.groupBy.op.notEqual': 'Not equal to',
  'listBuilder.drawer.groupBy.op.greaterThan': 'Greater than',
  'listBuilder.drawer.groupBy.op.greaterThanOrEqual': 'Greater than or equal to',
  'listBuilder.drawer.groupBy.op.lessThan': 'Less than',
  'listBuilder.drawer.groupBy.op.lessThanOrEqual': 'Less than or equal to',

  // Collaborators drawer (per the "AccessControl vs Collaborator" UX
  // guide) — mirrors the entity-builder keys exactly.
  'listBuilder.collaborators.title': 'Collaborators',
  'listBuilder.collaborators.addSection': 'Add collaborators',
  'listBuilder.collaborators.selectUsers': 'Select users',
  'listBuilder.collaborators.usersRequired': 'Select at least one user',
  'listBuilder.collaborators.add': 'Add collaborator',
  'listBuilder.collaborators.current': 'Current collaborators',
  'listBuilder.collaborators.remove.confirm': 'Remove collaborator?',
  'listBuilder.collaborators.remove.content': 'Are you sure you want to remove {userName}?',
  'listBuilder.collaborators.empty': 'No collaborators on this list',

  'listBuilder.drawer.taskBoard.title': 'Configure Task Board',
  'listBuilder.drawer.taskBoard.columns': 'Columns',
  'listBuilder.drawer.taskBoard.addColumn': 'Add column',
  'listBuilder.drawer.taskBoard.noColumns': 'No columns configured',
  'listBuilder.drawer.taskBoard.labels': 'Labels',
  'listBuilder.drawer.taskBoard.addLabel': 'Add label',
  'listBuilder.drawer.taskBoard.noLabels': 'No labels configured',
  'listBuilder.drawer.taskBoard.columnName': 'Column name',
  'listBuilder.drawer.taskBoard.columnOrder': 'Order',
  'listBuilder.drawer.taskBoard.columnColor': 'Column color',
  'listBuilder.drawer.taskBoard.labelTitle': 'Title',
  'listBuilder.drawer.taskBoard.labelColor': 'Color',
  'listBuilder.drawer.taskBoard.mapping': 'Mapping',
  'listBuilder.drawer.taskBoard.mapping.description': 'Map each data field to a task-board concept',
  'listBuilder.drawer.taskBoard.map.columnField': 'Column field',
  'listBuilder.drawer.taskBoard.map.titleField': 'Title field',
  'listBuilder.drawer.taskBoard.map.descriptionField': 'Description field',
  'listBuilder.drawer.taskBoard.map.assigneeField': 'Assignee field',
  'listBuilder.drawer.taskBoard.map.dueDateField': 'Due date field',
  'listBuilder.drawer.taskBoard.map.labelField': 'Label field',

  'listBuilder.drawer.gantt.title': 'Configure Gantt',
  'listBuilder.drawer.gantt.mapping': 'Field mapping',
  'listBuilder.drawer.gantt.description': 'Pick which field powers each Gantt bar property',
  'listBuilder.drawer.gantt.titleField': 'Title field',
  'listBuilder.drawer.gantt.startDateField': 'Start date',
  'listBuilder.drawer.gantt.endDateField': 'End date',
  'listBuilder.drawer.gantt.progressField': 'Progress field',
  'listBuilder.drawer.gantt.dependenciesField': 'Dependencies field',
  'listBuilder.drawer.gantt.assigneeField': 'Assignee field',

  'listBuilder.section.mapList': 'Map list',
  'listBuilder.drawer.mapList.title': 'Configure Map',
  'listBuilder.drawer.mapList.description': 'Pick the fields that hold geographic coordinates',
  'listBuilder.drawer.mapList.latitudeField': 'Latitude field',
  'listBuilder.drawer.mapList.longitudeField': 'Longitude field',
  'listBuilder.drawer.mapList.titleField': 'Title field',
  'listBuilder.drawer.mapList.descriptionField': 'Description field',
  'listBuilder.drawer.mapList.markerColorField': 'Marker color',

  'listBuilder.drawer.formMode.title': 'Edit mode',
  'listBuilder.drawer.formMode.description': 'Define how records are edited in the list',
  'listBuilder.drawer.formMode.inline': 'Inline editing',
  'listBuilder.drawer.formMode.inlineDesc': 'Fields are edited directly in the list row',
  'listBuilder.drawer.formMode.popup': 'Form editing',
  'listBuilder.drawer.formMode.popupDesc': 'Opens a separate form to edit the record',

  'listBuilder.traces.title': 'Traces',
  'listBuilder.traces.operation': 'Operation',
  'listBuilder.traces.creator': 'User',
  'listBuilder.traces.created': 'Date',
  'listBuilder.traces.version': 'Version',
  'listBuilder.traces.data': 'Data',
  'listBuilder.trace.generateTokenReadonly': 'Read token',
  'listBuilder.trace.generateTokenWrite': 'Write token',
  'listBuilder.trace.appendComponent': 'Add component',
  'listBuilder.trace.modifyComponent': 'Modify component',
  'listBuilder.trace.removeComponent': 'Remove component',
  'listBuilder.trace.publish': 'Publish',
  'listBuilder.trace.newVersionCreated': 'New version created',
};
